module.exports = __webpack_public_path__ + "static/media/calendarMaster.b4934e1e.png";